// Helper de telechargement de blobs authentifies (Sprint 2 §8).
//
// Les exports synchrones (mini-dossier, citations, notes-pdf) renvoient
// le binaire directement dans la reponse HTTP. Pour declencher un
// download cote navigateur tout en passant l'Authorization header,
// on fait un fetch + Blob + ancre <a download>.

import { useAuthStore } from '../stores/auth';

/**
 * Fetch authentifie + force le download avec le filename donne.
 *
 * @throws Error si la reponse n'est pas 2xx (le message contient le
 *   corps de la reponse pour faciliter le debug ; les problem-details
 *   ne sont pas formates ici, l'appelant peut afficher tel quel).
 */
export async function downloadBlob(path: string, filename: string): Promise<void> {
  const token = useAuthStore.getState().accessToken;
  const headers: HeadersInit = token ? { Authorization: `Bearer ${token}` } : {};
  const resp = await fetch(path, { headers });
  if (!resp.ok) {
    const text = await resp.text();
    throw new Error(text || `HTTP ${resp.status}`);
  }
  const blob = await resp.blob();
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  a.remove();
  URL.revokeObjectURL(url);
}
